import css from "@css/modules/BidSuggestion.module.scss"
import { ListingPricing } from "@components/Listings/ListingPricing/ListingPricing"
import { Listing } from "@t/Listing"
import { SuggestionSide } from "./components/SuggestionSide"
import { CloseIcon } from "@css/icons/CloseIcon"
import { useEffect, useState } from "react"
import { createPortal } from "react-dom"

export function BidSuggestion({ listing, onClose }: { listing: Listing; onClose: () => void }) {
    const [elem, setElem] = useState<HTMLDivElement>(null)
    useEffect(() => {
        const elem = document.createElement("div")
        setElem(elem)
        document.getElementById("dialog-portal")?.appendChild(elem)
        document.body.style.overflow = "hidden"
        return () => {
            document.body.style.overflow = ""
            document.getElementById("dialog-portal")?.removeChild(elem)
        }
    }, [])
    return (
        elem &&
        createPortal(
            <div className={css.root}>
                <div className={css.backdrop} onClick={() => onClose()} />
                <div className={css.container}>
                    <ListingPricing
                        listing={listing}
                        className={css.pricing}
                        classes={{
                            headerWrapper: css.headerWrapper,
                            daysOnMarket: css.daysOnMarket,
                            btnWrap: css.btnWrap,
                            onMarket: css.onMarket
                        }}
                        headerContent={<div className={css.pricingResortName}>{listing?.resort?.short_name}</div>}
                    />
                    <SuggestionSide listing={listing} />
                    <button className={css.closeBtn} onClick={() => onClose()}>
                        <CloseIcon />
                    </button>
                </div>
            </div>,
            elem
        )
    )
}
